import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import ColisLogistiqueQualification from 'components/Shared/ColisLogistiqueQualification';
import DepannageDirectClient from 'components/Shared/DepannageDirectClient';
import DropZone from 'components/Shared/DropZone';
import LigneGestionQualification from 'components/Shared/LigneGestionQualification';
import NumberFormatQuantite from 'components/Shared/NumberFormatQuantite';
import PieceGestionSearch from 'components/Shared/PieceGestionSearch';

import InfoSuiviColis from 'components/Shared/InfoSuiviColis';

import { ReclamationQualificationDetailCodes } from 'constants.js';
import { ReclamationQualificationDetailType } from 'constants.js';
import { AnomalieType } from 'constants.js';
import { TypeCodes } from 'constants.js';

const styles = theme => ({
    flexContainer: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    row: {
        flexBasis: '100%',
        marginBottom: '10px'
    },
    formControl: {
        margin: 0
    },
    group: {
        margin: theme.spacing(1, 0)
    },
    heightLabel: {
        height: '30px'
    }
});

const Etape = {
    ChoixDeLaPiece: 0,
    Qualifications: 1
};

class ManqueColisStep extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            expandedPanel: 'panelPiece',
            etape: Etape.ChoixDeLaPiece
        };
    }

    componentDidMount() {
        // On détermine si on doit rendre accessible le bouton pour passer à l'étape suivante ou le bouton de création.
        const { reclamation, onNextStepValid } = this.props;

        // On vérifie que la réclamation possède un enregistrement pour chaque détail.
        let nextStepValid = false;
        if (reclamation !== null && reclamation.qualificationDetails.length > 0) {
            const detailNbColisRecus = this.getNbColisRecus();
            const detailReserveTransporteurFaite = this.getReserveTransporteurFaite();

            if (detailNbColisRecus !== '' &&
                detailReserveTransporteurFaite !== '' &&
                reclamation.numeroPiece.length > 0 &&
                reclamation.lignes.length > 0) {
                nextStepValid = true;
            }
        }

        onNextStepValid(nextStepValid);
    }

    getNbColisRecus() {
        const { reclamation } = this.props;

        let nbColisRecus = '';

        const detailNbColisRecus = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.NbColisRecus);
        if (detailNbColisRecus !== undefined) {
            nbColisRecus = detailNbColisRecus.valeurInteger;
        }

        return nbColisRecus;
    }

    getReserveTransporteurFaite() {
        const { reclamation } = this.props;

        let reserveTransporteurFaite = '';

        const detailReserveTransporteurFaite = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.ReserveTransporteurFaite);
        if (detailReserveTransporteurFaite !== undefined) {
            reserveTransporteurFaite = detailReserveTransporteurFaite.valeurBool;
        }

        return reserveTransporteurFaite;
    }

    getDepannageDirectClient() {
        const { reclamation } = this.props;

        let depannageDirectClient = '';

        const detailDepannageDirectClient = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.DepannageDirectClient);
        if (detailDepannageDirectClient !== undefined) {
            depannageDirectClient = detailDepannageDirectClient.valeurBool;
        }

        return depannageDirectClient;
    }

    getSuiviColisVerifie() {
        const { reclamation } = this.props;

        let suiviColisVerifie = '';

        const detailSuiviColisVerifie = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.SuiviColisVerifie);
        if (detailSuiviColisVerifie !== undefined) {
            suiviColisVerifie = detailSuiviColisVerifie.valeurInteger;
        }

        return suiviColisVerifie;
    }


    checkErrors(nbColisRecus, reserveTransporteurFaite, depannageDirectClient, suiviColisVerifie) {
        const { reclamation, utilisateurMagasin } = this.props;

        let errors = [];

        if (suiviColisVerifie === '') {
            errors.push({ key: ReclamationQualificationDetailCodes.SuiviColisVerifie, errorMsg: 'Le suivi colis a-t-il été vérifié ?' });
        } else {
            errors.push({ key: ReclamationQualificationDetailCodes.SuiviColisVerifie, errorMsg: null });
        }

        if (nbColisRecus === '') {
            errors.push({ key: ReclamationQualificationDetailCodes.NbColisRecus, errorMsg: 'Nombre de colis reçus obligatoires.' });
        } else {
            if (nbColisRecus === 0) {
                errors.push({ key: ReclamationQualificationDetailCodes.NbColisRecus, errorMsg: "Si aucun colis n'a été reçu, merci de créer le dossier dans la catégorie \"Commande pas arrivée\" avec la qualification \"Aucun colis arrivé\"" });
            } else {
                errors.push({ key: ReclamationQualificationDetailCodes.NbColisRecus, errorMsg: null });
            }
        }

        if (reserveTransporteurFaite === '') {
            errors.push({ key: ReclamationQualificationDetailCodes.ReserveTransporteurFaite, errorMsg: 'Veuillez indiquer si une réserve a été effectuée auprès du transporteur.' });
        } else {
            errors.push({ key: ReclamationQualificationDetailCodes.ReserveTransporteurFaite, errorMsg: null });
        }

        if (reclamation.numeroPiece.length === 0) {
            errors.push({ key: ReclamationQualificationDetailCodes.Piece, errorMsg: 'Veuillez sélectionner une pièce.' });
        } else {
            errors.push({ key: ReclamationQualificationDetailCodes.Piece, errorMsg: null });
        }

        if (reclamation.type.code === TypeCodes.Client && utilisateurMagasin) {
            if (depannageDirectClient === '') {
                errors.push({ key: ReclamationQualificationDetailCodes.DepannageDirectClient, errorMsg: 'Avez-vous résolu le problème de votre client ?' });
            } else {
                errors.push({ key: ReclamationQualificationDetailCodes.DepannageDirectClient, errorMsg: null });
            }
        }

        if (reclamation.ligneOuColis === 'ligne' && reclamation.lignes.length === 0) {
            errors.push({ key: ReclamationQualificationDetailCodes.NbLignes, errorMsg: 'Saisie obligatoire sur au moins une ligne.' });
        } else {
            errors.push({ key: ReclamationQualificationDetailCodes.NbLignes, errorMsg: null });
        }

        if (reclamation.ligneOuColis === 'colis' && reclamation.colis.length === 0) {
            errors.push({ key: ReclamationQualificationDetailCodes.NbColis, errorMsg: 'Sélectionnez au moins un colis.' });
        } else {
            errors.push({ key: ReclamationQualificationDetailCodes.NbColis, errorMsg: null });
        }

        return errors;
    }


    handleChangePanel = panel => (event, expandedPanel) => {
        this.setState({
            ...this.state,
            expandedPanel: expandedPanel ? panel : false
        });
    };

    handleChange = (event) => {
        const { onChange } = this.props;

        const nbColisRecus = this.getNbColisRecus();
        const reserveTransporteurFaite = this.getReserveTransporteurFaite();
        const depannageDirectClient = this.getDepannageDirectClient();
        const suiviColisVerifies = this.getSuiviColisVerifie();

        const errors = this.checkErrors(nbColisRecus, reserveTransporteurFaite, depannageDirectClient, suiviColisVerifies);

        onChange(event, errors);
    }

    handleSelectPiece = (value) => {
        const { onSelectPiece } = this.props;

        // On ouvre le panel avec les détails de la qualification.
        this.setState({
            ...this.state,
            expandedPanel: 'panelQualificationDetails',
            etape: Etape.Qualifications
        });

        const nbColisRecus = this.getNbColisRecus();
        const reserveTransporteurFaite = this.getReserveTransporteurFaite();
        const depannageDirectClient = this.getDepannageDirectClient();
        const suiviColisVerifies = this.getSuiviColisVerifie();

        const errors = this.checkErrors(nbColisRecus, reserveTransporteurFaite, depannageDirectClient, suiviColisVerifies);

        onSelectPiece(value, errors);
    }

    handleQualificationDetailsNbColisRecusChange = (event) => {
        const { onDetailChange } = this.props;

        const qualificationDetail = {
            position: 0,
            code: ReclamationQualificationDetailCodes.NbColisRecus,
            type: ReclamationQualificationDetailType.Nombre,
            libelle: 'Nombre de colis reçus ?',
            valeurInteger: parseInt(event.target.value, 10)
        };

        const errors = this.checkErrors(parseInt(event.target.value, 10), this.getReserveTransporteurFaite(), this.getDepannageDirectClient(), this.getSuiviColisVerifie());

        onDetailChange(qualificationDetail, errors, null);
    }

    handleQualificationDetailsReserveTransporteurFaiteChange = (event) => {
        const { onDetailChange } = this.props;

        const qualificationDetail = {
            position: 1,
            code: ReclamationQualificationDetailCodes.ReserveTransporteurFaite,
            type: ReclamationQualificationDetailType.Booleen,
            libelle: 'Avez-vous effectué une réserve auprès du transporteur ?',
            valeurBool: event.target.value
        };

        const nbColisRecus = this.getNbColisRecus();
        const reserveTransporteurFaite = event.target.value;
        const depannageDirectClient = this.getDepannageDirectClient();
        const suiviColisVerifies = this.getSuiviColisVerifie();

        const errors = this.checkErrors(nbColisRecus, reserveTransporteurFaite, depannageDirectClient, suiviColisVerifies);

        this.setState({
            ...this.state,
            expandedPanel: 'panelLignes'
        });

        onDetailChange(qualificationDetail, errors, null);
    }

    handleQualificationDetailsDepannageDirectClientChange = (event) => {
        const { onDetailChange } = this.props;

        const qualificationDetail = {
            position: 2,
            code: ReclamationQualificationDetailCodes.DepannageDirectClient,
            type: ReclamationQualificationDetailType.Booleen,
            libelle: 'Avez-vous résolu le problème de votre client ?',
            valeurBool: event.target.value
        };

        const errors = this.checkErrors(this.getNbColisRecus(), this.getReserveTransporteurFaite(), event.target.value, this.getSuiviColisVerifie());

        onDetailChange(qualificationDetail, errors, null);
    }

    handleAddLigne = (ligne) => {
        const { onAddLigne } = this.props;

        const errors = this.checkErrors(this.getNbColisRecus(), this.getReserveTransporteurFaite(), this.getDepannageDirectClient(), this.getSuiviColisVerifie());

        onAddLigne(ligne, errors);
    }

    handleRemoveLigne = (numeroLigne) => {
        const { onRemoveLigne } = this.props;

        const errors = this.checkErrors(this.getNbColisRecus(), this.getReserveTransporteurFaite(), this.getDepannageDirectClient(), this.getSuiviColisVerifie());

        onRemoveLigne(numeroLigne, errors);
    }

    handleLigneOuColisChange = (event) => {
        const { onLigneOuColisChange } = this.props;

        onLigneOuColisChange(event.target.value);
    }

    handleAddColis = (colisId, typeAnomalie) => {
        const { onAddColis } = this.props;

        const errors = this.checkErrors(this.getNbColisRecus(), this.getReserveTransporteurFaite(), this.getDepannageDirectClient(), this.getSuiviColisVerifie());

        onAddColis(colisId, typeAnomalie, errors);
    }

    handleRemoveColis = colisId => {
        const { onRemoveColis } = this.props;

        const errors = this.checkErrors(this.getNbColisRecus(), this.getReserveTransporteurFaite(), this.getDepannageDirectClient(), this.getSuiviColisVerifie());

        onRemoveColis(colisId, errors);
    }

    handleDetailSuiviColisVerifieChange = (event) => {
        const { onDetailChange } = this.props;

        const qualificationDetail = {
            position: 0,
            code: ReclamationQualificationDetailCodes.SuiviColisVerifie,
            type: ReclamationQualificationDetailType.ChoixSimple,
            libelle: 'Avez-vous vérifié votre suivi colis ?',
            valeurInteger: event.target.value,
            valeurString: event.target.labels[0].innerText
        };

        const suiviColisVerifie = event.target.value;
        const nbColisRecus = this.getNbColisRecus();
        const reserveTransporteurFaite = this.getReserveTransporteurFaite();
        const depannageDirectClient = this.getDepannageDirectClient();

        const errors = this.checkErrors(nbColisRecus, reserveTransporteurFaite, depannageDirectClient, suiviColisVerifie);

        onDetailChange(qualificationDetail, errors, null);
    }


    renderQualificationDetails() {
        const { classes } = this.props;

        const detailNbColisRecusValue = this.getNbColisRecus();
        const detailReserveTransporteurFaiteValue = this.getReserveTransporteurFaite();

        return (
            <React.Fragment>
                <div className={classes.row}>
                    <TextField
                        id="nb-colis-recus"
                        name="nb-colis-recus"
                        label="Nombre de colis reçus"
                        placeholder="Nombre de colis reçus"
                        value={detailNbColisRecusValue}
                        onChange={this.handleQualificationDetailsNbColisRecusChange}
                        InputProps={{
                            inputComponent: NumberFormatQuantite
                        }}
                        InputLabelProps={{
                            shrink: true
                        }}
                        required
                        error={detailNbColisRecusValue===0}
                        helperText={detailNbColisRecusValue===0?"Si aucun colis n'a été reçu, merci de créer le dossier dans la catégorie \"Commande pas arrivée\" avec la qualification  \"Aucun colis arrivé\"":''}
                    />
                </div>
                <div className={classes.row}>
                    <FormControl component="fieldset" className={classes.formControl} required>
                        <FormLabel component="legend">Avez-vous effectué une réserve auprès du transporteur ?</FormLabel>
                        <RadioGroup
                            name="reserve-transporteur-faite"
                            className={classes.group}
                            value={detailReserveTransporteurFaiteValue}
                            onChange={this.handleQualificationDetailsReserveTransporteurFaiteChange}
                        >
                            <FormControlLabel className={classes.heightLabel} value="true" control={<Radio />} label="Oui" />
                            <FormControlLabel className={classes.heightLabel} value="false" control={<Radio />} label="Non" />
                        </RadioGroup>
                    </FormControl>
                </div>
            </React.Fragment>
        );
    }

    renderDepannageDirectClient() {
        const { classes, reclamation, utilisateurMagasin } = this.props;

        const detailDepannageDirectClientValue = this.getDepannageDirectClient();

        if (reclamation.type.code === TypeCodes.Client && utilisateurMagasin) {
            return (<div className={classes.row}>
                <DepannageDirectClient
                    onDetailChange={this.handleQualificationDetailsDepannageDirectClientChange}
                    value={detailDepannageDirectClientValue}
                />
            </div>);
        } else {
            return null;
        }
    }

    renderSuiviColis() {
        const { classes, reclamation } = this.props;

        const detailSuiviColisVerifieValue = this.getSuiviColisVerifie();

        if (reclamation.numeroPiece !== '') {
            return (
                <FormControl component="fieldset" className={classes.formControl} required>
                    <FormLabel component="legend">
                        Avez-vous vérifié votre suivi colis ?
                        <InfoSuiviColis
                            numeroPiece={reclamation.pieceCle || reclamation.numeroPiece}
                            afficheSuiviColisDetaille
                        />
                    </FormLabel>
                    <RadioGroup
                        name="SUIVI_COLIS_VERIFIE"
                        className={classes.group}
                        value={detailSuiviColisVerifieValue}
                        onChange={this.handleDetailSuiviColisVerifieChange}
                    >
                        <FormControlLabel className={classes.heightLabel} value="0" control={<Radio />} label="Oui, j'ai trouvé les informations souhaitées (dossier après-vente cloturé automatiquement)." />
                        <FormControlLabel className={classes.heightLabel} value="1" control={<Radio />} label="Oui, mais je souhaite plus d'informations." />
                        <FormControlLabel className={classes.heightLabel} value="2" control={<Radio />} label="Non." />
                    </RadioGroup>
                </FormControl>
            );
        } else {
            return null;
        }
    }

    render() {
        const { classes, reclamation, namespace, autoriseChoixLigne, lignesUniquement } = this.props;
        const { etape, expandedPanel } = this.state;

        return (
            <React.Fragment>

                <div className={classes.row}>
                    <TextField
                        multiline
                        fullWidth
                        name="commentaire"
                        label="Commentaire"
                        placeholder="Décrire le problème rencontré"
                        maxRows="3"
                        onChange={this.handleChange}
                        value={reclamation.commentaire}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </div>

                <div className={classes.row}>
                    <DropZone id="fichiersIds" name="fichiersIds" onChange={this.handleChange} />
                </div>


                <div className={classes.row}>
                    <Accordion expanded={expandedPanel === 'panelPiece'} onChange={this.handleChangePanel('panelPiece')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            className={classes.panelSummary}
                        >
                            <Typography >Rechercher une pièce* (obligatoire pour accéder aux lignes)</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <PieceGestionSearch
                                onSelectPiece={this.handleSelectPiece}
                                client={reclamation.client}
                                withLignes
                                namespace={namespace}
                                warningReclamation
                                defautProduitInfos={false}
                                logistiqueInfos={false}
                                defautNumeroPiece={reclamation.numeroPiece}
                            />
                        </AccordionDetails>
                    </Accordion>


                    {reclamation.numeroPiece && etape === Etape.Qualifications && (
                        <React.Fragment>

                            <Accordion expanded={expandedPanel === 'panelQualificationDetails'} onChange={this.handleChangePanel('panelQualificationDetails')}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    className={classes.panelSummary}
                                >
                                    <Typography >Qualification</Typography>
                                </AccordionSummary>

                                <AccordionDetails>
                                    <Grid
                                        container
                                        spacing={6}
                                        direction="column"
                                        justifyContent="space-between"
                                    >
                                        <Grid item>
                                            {this.renderSuiviColis()}
                                        </Grid>
                                        <Grid item>
                                            {this.renderQualificationDetails()}
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>

                            </Accordion>

                            <Accordion sx={{ mt: 2 }} expanded={expandedPanel === 'panelLignes'} onChange={this.handleChangePanel('panelLignes')}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.panelSummary}>

                                    {!lignesUniquement && autoriseChoixLigne && (
                                        <Typography >Sélectionner une ligne* ou un colis* (au moins une ligne en anomalie pour pouvoir créer le dossier après-vente)</Typography>
                                    )}

                                    {lignesUniquement && autoriseChoixLigne && (
                                        <Typography >Sélectionner une ligne* (au moins une ligne en anomalie pour pouvoir créer le dossier après-vente)</Typography>
                                    )}

                                    {!autoriseChoixLigne && (
                                        <Typography >Sélectionner un colis* (au moins une ligne en anomalie pour pouvoir créer le dossier après-vente)</Typography>
                                    )}
                                </AccordionSummary>
                                <AccordionDetails className={classes.flexContainer}>

                                    {!lignesUniquement && (
                                        <div className={classes.row}>
                                            <FormControl component="fieldset" className={classes.formControl} required>
                                                {autoriseChoixLigne &&
                                                    <FormLabel component="legend">Sélectionner : - une ou plusieurs lignes - le ou les colis manquants</FormLabel>
                                                }
                                                {!autoriseChoixLigne &&
                                                    <FormLabel component="legend">Sélectionner : - les colis manquants</FormLabel>
                                                }
                                                <RadioGroup
                                                    name="ligne-ou-colis"
                                                    className={classes.group}
                                                    value={reclamation.ligneOuColis}
                                                    onChange={this.handleLigneOuColisChange}
                                                >
                                                    {autoriseChoixLigne &&
                                                        <FormControlLabel className={classes.heightLabel} value="ligne" control={<Radio />} label="Ligne(s)" />
                                                    }
                                                    <FormControlLabel className={classes.heightLabel} value="colis" control={<Radio />} label="Colis" />
                                                </RadioGroup>
                                            </FormControl>
                                        </div>
                                    )}


                                    <div className={classes.row}>
                                        {reclamation.ligneOuColis === 'ligne' &&
                                            <LigneGestionQualification
                                                reclamation={reclamation}
                                                onAddLigne={this.handleAddLigne}
                                                onRemoveLigne={this.handleRemoveLigne}
                                                typeAnomalie={AnomalieType.QuantiteArticleIncorrecte}
                                                disableCompose
                                                namespace={namespace}
                                                afficherQuantiteRetournable
                                            />
                                        }

                                        {reclamation.ligneOuColis === 'colis' &&
                                            <ColisLogistiqueQualification
                                                reclamation={reclamation}
                                                onAddColis={this.handleAddColis}
                                                onRemoveColis={this.handleRemoveColis}
                                                typeAnomalie={AnomalieType.QuantiteArticleIncorrecte}
                                                warningSelectionComplete={true}
                                            />
                                        }

                                    </div>
                                </AccordionDetails>
                            </Accordion>


                            {this.renderDepannageDirectClient()}

                        </React.Fragment>)
                    }


                </div>
            </React.Fragment>
        );
    }
}

ManqueColisStep.propTypes = {
    reclamation: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onDetailChange: PropTypes.func.isRequired,
    onSelectPiece: PropTypes.func.isRequired,
    onLigneOuColisChange: PropTypes.func.isRequired,
    onAddLigne: PropTypes.func.isRequired,
    onRemoveLigne: PropTypes.func.isRequired,
    onAddColis: PropTypes.func.isRequired,
    onRemoveColis: PropTypes.func.isRequired,
    validationErrors: PropTypes.array,
    onNextStepValid: PropTypes.func.isRequired,
    namespace: PropTypes.string.isRequired
};

export default withStyles(styles)(ManqueColisStep);